import { render, staticRenderFns } from "./nshop-order-view-table.vue?vue&type=template&id=61a8b9be&scoped=true&"
import script from "./nshop-order-view-table.vue?vue&type=script&lang=js&"
export * from "./nshop-order-view-table.vue?vue&type=script&lang=js&"
import style0 from "./nshop-order-view-table.vue?vue&type=style&index=0&id=61a8b9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a8b9be",
  null
  
)

export default component.exports